export const SUPPORTED_LANGUAGES = ['en', 'zh-Hans', 'zh-Hant'];

export const LANGUAGE_CODE_MAP = {
  en: 'English',
  ar: 'العربية',
  bg: 'България',
  cs: 'Cesky',
  da: 'Dansk',
  de: 'Deutsch',
  el: 'Ελληνικά',
  es: 'Español',
  fi: 'Suomi',
  fr: 'Français',
  he: 'עברית',
  hu: 'Magyar Nyelv',
  id: 'Bahasa Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  ms: 'Bahasa Melayu',
  nb: 'Norsk Bokmål',
  nl: 'Nederlands',
  pl: 'Polski',
  pt: 'Português',
  ro: 'Română',
  ru: 'Pусский',
  sv: 'Svenska',
  th: 'ไทย',
  tl: 'Tagalog',
  tr: 'Türkçe',
  vi: 'Tiếng Việt',
  'zh-Hant': '繁体中文',
  'zh-Hans': '简体中文',
  bn: 'বাংলা',
  bo: 'བོད་ཡིག',
  ca: 'Català',
  et: 'Eesti',
  eu: 'Euskara',
  fa: 'فارسی',
  hi: 'हिन्दी',
  hr: 'Hrvatska',
  ht: 'Kreyòl Ayisyen',
  is: 'Íslenska',
  pa: 'ਪੰਜਾਬੀ',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  sr: 'Српски',
  sw: 'Kiswahili',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  uk: 'український',
  ug: 'ئۇيغۇر تىلى',
  ur: 'اردو',
  uz: "o'zbekcha",
  af: 'Afrikaans',
  cy: 'Cymraeg',
  fl: 'Vlaams',
  ga: 'An Ghaeilge',
  sq: 'Shqip',
  lv: 'Latviešu Valoda',
  km: 'ភាសាខ្មែរ',
  la: 'Lingua Latina',
};
